const toastMessages = {
  genericErrorHeading: "Something went wrong!",
  genericErrorDescription: "Please try again later",
  requestTimeoutHeading: "Slow network is detected",
  requestTimeoutDescription: "Please try again later",
  genericSuccessMessage: "Action successful",
};

export default toastMessages;